import styled from 'styled-components';

const ButtonStyle = styled.div`
  button {
    min-width: 180px;
    height: 40px;
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.normal;
    }};
    box-shadow: ${({ theme }) => {
      return theme.shadow;
    }};
    color: ${({ theme }) => {
      return theme.colors.white;
    }};
    font-family: inherit;
    font-size: ${({ theme }) => {
      return theme.fonts.size.big;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.normal;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.green;
    }};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;

    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkGreen;
      }};
    }
    &:disabled {
      background-color: #888;
    }
  }
`;
export default ButtonStyle;
